// import { Input } from 'antd';
import React from "react";
import _ from "lodash";
import * as Yup from "yup";
import { Formik, useFormik } from "formik";
import { lf3Constants } from "../CRM/lf3Constants";
import "./Select.css";
import { Select } from "antd";
const { Option } = Select;

export default function SelectInput(props) {
  const id = JSON.stringify(props.id);

  const fieldOpts = props.fieldOptions;

  return (
    <div style={{ marginTop: 20 }}>
      <div style={{ position: "relative" }} className="lf3Parent">
        <Select
          autoClearSearchValue={true}
          onChange={props.handleChange(id)}
          value={props.values[props.id] || null}
          placeholder={props.name}
          // showSearch={true}
          style={{
            width: "80%",
            height: 45,
            fontSize: 14,
            marginLeft: 15,
            marginRight: 15,
            borderWidth: 1,
            borderRadius: 5,
          }}
          onBlur={props.handleBlur(id)}
        >
          {_.map(fieldOpts, (item, index) => {
            return (
              <Option key={index} value={item.optionValue}>
                {item.optionValue}
              </Option>
            );
          })}
        </Select>
        {props.touched[props.id] && props.errors[props.id] && (
          <p
            style={{
              color: "red",
              fontSize: 12,
              textAlign: "left",
              position: "relative",
              marginLeft: 40,
              marginBottom: 20,
              marginTop: 10,
            }}
          >
            {props.errors[props.id]}
          </p>
        )}
      </div>
    </div>
  );
}
